import React, { useState, useContext, createRef, useEffect } from 'react';
import { Header, Checkbox, Card, Container, Segment, Sticky, Grid, Input, GridRow, Divider, GridColumn, ButtonContent } from 'semantic-ui-react';
import { Button, Form, Icon, Image, List, Label, Transition, Modal, Message, Progress } from 'semantic-ui-react';
import { Link, useParams } from 'react-router-dom';
import { AppState } from '../../context';
import { Loader, Dimmer } from 'semantic-ui-react';
import { dbCaregivers, dbFamMember } from '../../firebase';
import firebase from 'firebase/app';
import 'firebase/functions';

const AddFamilyMemberView = ({ userr, inst}) => {
  const sendText = firebase.functions().httpsCallable('sendText');
  const someContext = useContext(AppState);
  const {
    correct,
    setCorrect,
    tasks,
    caregivers,
    familyMembers
  } = someContext;

  const { userid, bool } = useParams();
  const contextRef = createRef();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [firstName, setFirstName] = useState(null);
  const [lastName, setLastName] = useState(null);
  const [phone, setPhone] = useState(null);
  const [username, setUsername] = useState("");
  const [rating, setRating] = useState(5);
  const [password, setPassword]=useState("");
  const [existingCaregivers, setCaregivers] = useState([]);

  function WriteFirebase() {
    if (!(isNaN(Number(phone))) && (typeof (firstName) == "string" && typeof (lastName) == "string") && !familyMembers[username]) {
      setIsModalOpen(true);
      var temppassword = Math.random().toString(36).slice(7)

      const constant = {
        firstName: firstName,
        lastName: lastName,
        phone: phone,
        familyMembers: userid,
        password: password,
        type: "secondary"

      }

      const dataToPush = {
        [username]: constant
      }
      //var k = dbFamMember.push(dataToPush);
      dbFamMember.update(dataToPush);
      // let original_key = k.key;
      // var key =k.key;

      let key = username

      var temp = [];
      if (familyMembers && familyMembers[userid] && familyMembers[userid]["secondaryFam"] && familyMembers[userid]["secondaryFam"] !== "hi") {
        temp = Object.values(familyMembers[userid]["secondaryFam"])
        console.log("it should print this")
      }
      console.log(familyMembers)
      console.log(familyMembers[userid])
      // console.log(familyMembers[userid]["secondaryFam"])
      console.log(temp);
      temp.push(key)
      dbFamMember.child(userid).update({ secondaryFam: temp })
      //dbFamMember.update({[original_key]: temp})
      reboot()
    //   sendText({
    //     data: {
    //       to: phone, body:
    //         `You've been added as a secondary familymember to Homecare! Please go to thefinalhomecare.firebaseapp.com/viewfamily/${key} Your unique password is ${temppassword}
    // ` }
    //   });
    }
    else {
      if (familyMembers[username]) {
        alert("Please try another username! The one you wanted is already taken.")
      }
      else {
        alert("That username's taken - please try another!")

      }
    }
    const isValid = () => {
      console.log("this is the outcome bro")
      var x = (!isNaN(Number(phone))) && (typeof (firstName) == "string" && typeof (lastName) == "string")
      console.log(x)
      console.log(typeof (firstName) == "string")
      console.log(typeof (lastName) == "string")
      console.log(!isNaN(Number(phone)))
      return (x)

    }

  }
  function reboot() {
    setFirstName("")
    setLastName("")
    setPhone("")
  }
  const PageHeader = () => {
    var header = inst ? inst: "Homecare";
    return (
      <Segment
        basic
        style={{ backgroundColor: "#006990", textAlign: "center", marginBottom: "0px" }}
        fluid="true"
      >
        <Grid columns={2}>
          <Grid.Column width='3' />
          <Grid.Column width='10'>
            <Header
              // as={(!isNaN(Number(phone))) && (typeof(firstName) =="string" && typeof(lastName)=="string") ? Link : Button}
              // to={(!isNaN(Number(phone))) && (typeof(firstName) =="string" && typeof(lastName)=="string") ? "/" : ""}
              inverted
              content={header}
              size="large"
              color="black"
              style={{ cursor: "default" }}
            />
          </Grid.Column>
        </Grid>
      </Segment>
    );
  };


  return (
    <div ref={contextRef}>
      <Sticky context={contextRef} >
        <PageHeader />

        <Modal open={isModalOpen} basic size='small' onClose={() => setIsModalOpen(false)}>
          <Header icon='checkmark' content='Complete!' />
          <Modal.Content>
            <p>
              Added! They will be notified via text.
      </p>
          </Modal.Content>
          <Modal.Actions>
            <Button color='green' inverted onClick={() => setIsModalOpen(false)}>
              <Icon name='pen square' /> Add Another
      </Button>
            <Button color='green' inverted as={Link} 
            to= {bool == 0 ? 
              familyMembers[userid]["careBool"] ? inst  ? `/${inst}/familymembers/register/recommended/${userid}` :
              `/familymembers/register/recommended/${userid}`:
               `/familymembers/summary/${userid}`
               : 
               `/familymembers/profile/${userid}`}
            >
              <Icon name='checkmark' /> Continue
      </Button>
          </Modal.Actions>
        </Modal>



        {/* <Grid padded textAlign="center">
          <Grid.Row>
            <Form size="large" >
              <Form.Group widths='equal'>
                <Form.Input
                 
                  required={true}
                  label='FamilyMember First Name:'
                  value={firstName}
                />
              </Form.Group>
              <Form.Group widths='equal'>
                <Form.Input
                required={true}
                  onChange={(e) => { setLastName(e.target.value) }}
                  label='FamilyMember Last Name:'
                  value={lastName}
                />
              </Form.Group>
              <Form.Group widths='equal'>
                <Form.Input
                  required={true}
                  onChange={(e) => { setUsername(e.target.value) }}
                  label='Username:'
                  value={username}
                />
              </Form.Group>
              <Form.Group widths='equal'>
                <Form.Input
                  onChange={(e) => { setPhone(e.target.value) }}
                  required={true}
                  label='Their Number:'
                  value={phone}
                />
              </Form.Group>
            </Form>
            </Grid.Row>

        </Grid> */}


        <Grid textAlign='center' style={{ height: '10vh' }} padded>
          <Divider hidden />
          <Grid.Row>
            <Grid.Column style={{ marginLeft: "30px", marginRight: "30px", maxWidth: 450 }}>
              <Progress percent={75} indicating />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column style={{ maxWidth: 450 }}>
              <Header as="h5">
                Enter their information:
              </Header>
              <Form size='large' >
                <Segment stacked>
                  <Form.Input
                    required={true}
                    onChange={(e) => { setFirstName(e.target.value) }}
                    id='form-subcomponent-shorthand-input-first-name'
                    placeholder='First Name'
                  />
                  <Form.Input
                    required={true}
                    onChange={(e) => { setLastName(e.target.value) }}
                    id='form-subcomponent-shorthand-input-first-name'
                    placeholder='Last Name'
                  />
                  <Form.Input
                    required={true}
                    onChange={(e) => { setPhone(e.target.value) }}
                    id='form-subcomponent-shorthand-input-first-name'
                    placeholder='Their Phone number'
                  />
                  <Form.Input fluid icon='user'
                    iconPosition='left'
                    onChange={(e) => { setUsername(e.target.value) }}
                    placeholder='Their Username' />
                     <Form.Input fluid icon='key'
                    iconPosition='left'
                    onChange={(e) => { setPassword(e.target.value) }}
                    placeholder='Their Password' />


                  <Button
                    color='teal'
                    fluid
                    size='large'
                    onClick={() => WriteFirebase()} >
                    Continue
                    </Button>
                </Segment>
                {/* {error ? <div style={{ maxWidth: 450 }}>
                  <Message
                    warning
                    floating
                    content="This username already exists! Please choose another"
                    size="tiny"
                  />
                </div> : ""} */}
              </Form>
              <Message>
                Your privacy is important to us<a href='/privacy'> Privacy policy</a>
              </Message>
            </Grid.Column>
          </Grid.Row>
        </Grid>







      </Sticky>
    </div>
  );
}

export default AddFamilyMemberView;